import React, { useState } from 'react';
import { History } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import FileUpload from './ui/file-upload';
import { useTheme } from '../contexts/ThemeContext';

export default function FolderUploader() {
  const [files, setFiles] = useState([]);        // array of File objects
  const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();
  const { darkMode } = useTheme();

  const handleUpload = async () => {
    if (!files.length) return;
    setUploading(true);
    // pass the real File objects via router state
    navigate('/extract', { state: { files } });
  };

  return (
    <div className="max-w-6xl mx-auto">
      {/* Hero */}
      <div className="text-center mb-10">
        <h1 className={`text-4xl sm:text-5xl font-bold tracking-tight mb-4 transition-colors duration-300 ${darkMode ? 'text-white' : 'text-gray-900'
          }`}>
          Turn invoices into{' '}
          <span className="bg-gradient-to-r from-[#1B5F6E] to-[#2A8A9E] bg-clip-text text-transparent">
            structured data
          </span>
        </h1>
        <p className={`text-lg max-w-2xl mx-auto transition-colors duration-300 ${darkMode ? 'text-gray-300' : 'text-gray-600'
          }`}>
          Upload a German invoice, bank statement or card report. The app reads every
          page and fills in Halle, Rechnungsnummer, dates and amounts. Everything is
          validated before you see it.
        </p>
      </div>

      {/* How it works */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        {[
          { n: '01', t: 'Upload PDFs', d: 'Drag files in. One PDF or a whole folder.' },
          { n: '02', t: 'Extraction', d: 'Text layers are read directly, scans go through Docling. Qwen3 fills the fields.' },
          { n: '03', t: 'Review & export', d: 'Check the fields in the table, copy them or download the JSON.' },
          ].map((s, i) => (
            <div key={s.n} className={`relative rounded-xl p-5 transition-colors duration-300 ${darkMode
              ? 'bg-gray-800/70 border border-gray-700'
              : 'bg-white border border-[#1B5F6E]/10 shadow-sm'
              }`}>
              <span className="text-2xl font-bold bg-gradient-to-r from-[#1B5F6E] to-[#2A8A9E] bg-clip-text text-transparent">
                {s.n}
              </span>
              <h3 className={`mt-1 font-semibold transition-colors duration-300 ${darkMode ? 'text-white' : 'text-gray-900'
                }`}>{s.t}</h3>
              <p className={`mt-1 text-sm transition-colors duration-300 ${darkMode ? 'text-gray-400' : 'text-gray-600'
                }`}>{s.d}</p>
              {i < 2 && (
                <div className={`hidden md:block absolute top-1/2 -right-3 w-6 h-px ${darkMode ? 'bg-gray-700' : 'bg-[#1B5F6E]/20'
                  }`} />
              )}
            </div>
          ))}
      </div>

      {/* Upload Section */}
      <div className={`rounded-lg shadow-lg p-8 transition-colors duration-300 ${darkMode ? 'bg-gray-800 border border-gray-700' : 'bg-white'
        }`}>
        <FileUpload onFilesChange={setFiles} />

        {files.length > 0 && (
          <div className="mt-8">
            <div className="mt-2 flex justify-between items-center">
              <Button
                onClick={() => navigate('/history')}
                className="bg-gray-100 hover:bg-gray-200 text-gray-700"
              >
                <History className="w-4 h-4 mr-2" />
                View History
              </Button>
              <Button onClick={handleUpload} disabled={uploading} className="bg-gradient-to-r from-[#1B5F6E] to-[#2A8A9E] hover:from-[#164E5A] hover:to-[#237584] text-white disabled:opacity-50">
                {uploading ? 'Preparing…' : `Extract Data from ${files.length} PDF${files.length > 1 ? 's' : ''}`}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


